import React, { useState, useEffect, createRef } from 'react';
import { Link } from 'react-router-dom';
import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import { useAuth } from '../../../components/content/auth.jsx';
import env from '../../../environment.js';
import { subscribe, unsubscribe } from '../../../components/events';
import EntregasXProductorFirma from './entregas-x-productor-firma-pago-pendiente.js';
import EntregasXProductorInfo from './entregas-x-productor-info-acopio.js';
import EntregasXProductorBuscador from './entregas-x-productor-buscador.js';
import './entregas-x-productor.css';
import ExampleCustomInput from '../../../components/modal/input.jsx';
import DatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import FormInputMaterialTest from '../../../nuup/componentes/Forms/FormInputMaterialTest.jsx';
import FormSelectMaterial from '../../../nuup/componentes/Forms/FormSelectMaterial.jsx';

import { useParams } from 'react-router-dom';
// import Select from 'react-select';
import formatMoneyNumber, { formatNumber } from '../../../utils/formatNumber.js';
import { es } from 'date-fns/locale';
import { useCoopConfig } from '../../../components/content/coop-config.jsx';
import transformWord from '../../../utils/transformWord.js';

var curr = new Date();

const EntregasXProductorPagoPendiente = () => {
  // const auth = useAuth();
  const coopConfig = useCoopConfig();
  const { id_cuenta, uuid_cuenta, id_acopio } = useParams();
  const [date, setDate] = useState(null);
  const [dataForm, setDataForm] = useState({});
  const [showForm, setShowForm] = useState(true);
  const [showFirma, setShowFirma] = useState(false);
  const [metodosPago, setMetodosPago] = useState([]);
  const [pendientePago, setPendientePago] = useState(null);
  const [entregas, setEntregas] = useState();
  const [pagos, setPagos] = useState();
  const [blocking, setBlocking] = useState(true);
  const [cuenta, setCuenta] = useState();
  const [idMetodoPago, setIdMetodoPago] = useState('');
  const [pendientePagoCredito, setPendientePagoCredito] = useState(0);
  const [etiquetaAnticipos, setEtiquetaAnticipos] = useState('-');
  const [errorPagoExcedido, setErrorPagoExcedido] = useState(false);
  const [pagoTotal, setPagoTotal] = useState(0);

  // const customStyles = {
  //   control: base => ({
  //     ...base,
  //     flexDirection: 'row-reverse',
  //   }),
  //   clearIndicator: base => ({
  //     ...base,
  //     position: 'absolute',
  //     right: 0,
  //   }),
  // };

  useEffect(() => {
    getMetodosPago();
    getEtiquetaAnticipo();
  }, [coopConfig.config]);

  const getEtiquetaAnticipo = async () => {
    let etiqueta = await coopConfig.etiquetaAnticipos();
    setEtiquetaAnticipos(etiqueta);
  };

  useEffect(() => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    setDate(curr.toISOString().substring(0, 10));

    subscribe('Entrega::onReturn', e => handleReturn(e));
    subscribe('Entrega::Entregas', e => handleEntregas(e));
    subscribe('Entrega::Pagos', e => handlePagos(e));
    subscribe('Entrega::Cuenta', e => handleCuenta(e));
    subscribe('Entrega::Creditos', e => handleCreditos(e));
    return () => {
      unsubscribe('Entrega::onReturn');
      unsubscribe('Entrega::Entregas');
      unsubscribe('Entrega::Pagos');
      unsubscribe('Entrega::Cuenta');
      unsubscribe('Entrega::Creditos');
    };
  }, []);

  const handleCuenta = event => {
    setCuenta(event.detail);
  };

  const handleEntregas = event => {
    setEntregas(event.detail);
  };

  const handleCreditos = event => {
    setValue('creditos', event.detail.raw);
    setPendientePagoCredito(event.detail.total_saldo);
  };

  const handlePagos = event => {
    setPagos(event.detail);
    let pendientePago = getSaldoEntregas(
      event.detail?.pagos_total || 0,
      event.detail?.pagos_descuentos_total || 0,
      event.detail?.pagos_pagado_total || 0
    );
    setPendientePago(pendientePago);
  };

  const handlerSelectMetodoPago = selectedOption => {
    setIdMetodoPago(selectedOption);
    setValue('id_metodo_pago', selectedOption);
  };

  const handleReturn = event => {
    setShowForm(true);
    setShowFirma(false);
  };

  const [formData] = useState({
    id_acopio: id_acopio,
    id_cuenta: id_cuenta,
    id_ciclo: localStorage.getItem(`${env.appName}-ciclo_id`),
    fecha_ejecucion: curr,
    id_metodo_pago: '',
    monto_pagado: '',
    recuperacion_credito: '',
  });

  const schema = yup.object().shape({
    id_acopio: yup.number().min(0),
    id_cuenta: yup.number().min(1),
    fecha_ejecucion: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .required('Información obligatoria'),
    id_metodo_pago: yup
      .number()
      .required('Información obligatoria')
      .min(1, 'Información obligatoria'),
    monto_pagado: yup
      .number()
      .min(
        0.01,
        `El monto debe ser mayor a 0 ${
          pendientePagoCredito > 0
            ? '(si todo el pago se irá en recuperación de ' + transformWord(etiquetaAnticipos, ['plural']) + ', dejarlo en blanco)'
            : ''
        }`
      )
      .max(formatNumber(pendientePago), 'El monto no debe ser mayor a $ ' + formatMoneyNumber(pendientePago))
      .transform(value => (isNaN(value) ? undefined : value))
      .when([], {
        is: () => pendientePagoCredito > 0,
        then: schema => schema.notRequired(),
        otherwise: schema => schema.required('Información obligatoria'),
      }),
    recuperacion_credito: yup
      .number()
      .min(0, 'Se espera un valor mayor o igual a 0')
      .max(formatNumber(pendientePagoCredito), 'Se espera un valor menor o igual a ' + formatMoneyNumber(pendientePagoCredito))
      .transform(value => (isNaN(value) ? undefined : value))
      .nullable(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    // reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues: formData,
  });

  const montoPagado = watch('monto_pagado');
  const recuperacionCredito = watch('recuperacion_credito');

  useEffect(() => {
    if (
      errors.monto_pagado ||
      errors.recuperacion_credito ||
      isNaN(Number(montoPagado)) ||
      isNaN(Number(recuperacionCredito) || isNaN(Number(pendientePago)))
    ) {
      setErrorPagoExcedido(false);
      return;
    }

    const pagoTotal = Number(montoPagado) + Number(recuperacionCredito || 0);
    setPagoTotal(pagoTotal);
    if (pagoTotal > pendientePago && Number(montoPagado) <= pendientePago) {
      setErrorPagoExcedido(
        `La suma del pago y recuperación de ${transformWord(etiquetaAnticipos, ['plural'])} no puede ser mayor al pago pendiente: ${
          coopConfig.currency()?.symbol
        }${formatMoneyNumber(pendientePago)}`
      );
    } else {
      setErrorPagoExcedido(false);
    }
  }, [montoPagado, recuperacionCredito, errors, pendientePago, pendientePagoCredito, etiquetaAnticipos, coopConfig]);

  const onSubmit = values => {
    setDataForm(values);
    setShowFirma(true);
    setShowForm(false);
  };

  const getMetodosPago = () => {
    Api.getAll('acopios/catalogos/metodos_pago').then(response => {
      let _items = response.data.map(function(item) {
        return { value: item['id'], label: item['nombre'] };
      });
      setMetodosPago(_items);
      if (_items.length === 1) {
        setIdMetodoPago(_items[0].value);
        setValue('id_metodo_pago', Number(_items[0].value));
      }
    });
  };

  // useEffect(() => {
  //   getData();
  // }, []);

  // const getData = () => {
  //   setBlocking(true);
  //   Api.get('admin/acopios/entregas/lotes', localStorage.getItem(`${env.appName}-ciclo_id`)).then(response => {
  //     let _items = response.data.map(function(item) {
  //       return {
  //         value: item['id'],
  //         label: item['nombre'] + ' | ' + item['folio'],
  //         folio: item['folio'],
  //         volumen: item['volumen'],
  //       };
  //     });
  //     // Set initial value
  //     // eslint-disable-next-line eqeqeq
  //   });
  // };

  const getSaldoEntregas = (pagos_total, pagos_descuentos_total, pagos_pagado_total) => {
    return (pagos_total || 0) - (pagos_descuentos_total || 0) - (pagos_pagado_total || 0);
  };


  return (
    <div>
      <div className="mb-3">
        <EntregasXProductorBuscador uuid_cuenta={uuid_cuenta} />
      </div>

      <CardContainer height={'100%'}>
        <div className="row">
          <div className="col-md-12 col-lg-7">
            {showForm && (
              <CardContainer height={'100%'}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-xl-10 col-lg-12">
                      <p className="titulo-input">{'Registro de pago pendiente'}</p>

                      <Controller
                        control={control}
                        name="fecha_ejecucion"
                        render={({ field }) => (
                          <DatePicker
                            customInput={<ExampleCustomInput />}
                            dateFormat={'dd/MMM/yyyy'}
                            onChange={date => field.onChange(date)}
                            selected={field.value}
                            wrapperClassName="w-100"
                            locale={es}
                          />
                        )}
                      />
                      {errors?.fecha_ejecucion && <div className="invalid-feedback">{errors?.fecha_ejecucion.message}</div>}
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-xl-10 col-lg-12">
                      <p className="titulo-input">{'Datos de pago'}</p>
                    </div>
                  </div>

                  {!isNaN(pendientePago) && pendientePago > 0 ? (
                    <div className="row" style={{ marginBottom: -20, paddingLeft: 12 }}>
                      <p className={'info-input'}>
                        Saldo de la entrega {'  '}
                        <span>&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;</span>
                        <b>{coopConfig.currency()?.symbol + formatMoneyNumber(pendientePago)}</b>
                      </p>
                    </div>
                  ) : null}

                  <div className="row mt-4">
                    <div className="col-xl-10 col-lg-12">
                      <FormInputMaterialTest
                        id="monto_pagado"
                        type="number"
                        name="monto_pagado"
                        label=""
                        placeholder={`Monto pagado (${coopConfig.currency()?.symbol})`}
                        error={errors.monto_pagado}
                        register={register}
                        step=".01"
                      />
                    </div>

                    {/* Descuento de creditos logic is disabled for now 
                      {pendientePagoCredito > 0 ? (
                        <>
                          <div className="row mb-3">
                            <FormInputMaterialTest
                              id="recuperacion_credito"
                              type="number"
                              name="recuperacion_credito"
                              label=""
                              placeholder={`Recuperación ${transformWord(etiquetaAnticipos, ['plural'])} (${
                                coopConfig.currency()?.symbol
                              })`}
                              error={errors.recuperacion_credito}
                              register={register}
                              step=".01"
                            />
                          </div>

                          <p className="ml-3">
                            {`Saldo pendiente de ${transformWord(etiquetaAnticipos, ['plural'])} ${coopConfig.currency()?.symbol} ` +
                              formatMoneyNumber(+pendientePagoCredito - +recuperacionCredito)}
                          </p>
                        </>
                      ) : null}
                       */}
                  </div>

                  <div className="row mt-3" style={{ marginBottom: -20, paddingLeft: 12 }}>
                    <p className={'info-input'}>
                      Pago pendiente <span>&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;</span>
                      <b>{`${coopConfig.currency()?.symbol} ` + formatMoneyNumber(+pendientePago - +montoPagado - +recuperacionCredito)}</b>
                    </p>
                  </div>

                  {errorPagoExcedido ? (
                    <div className="row">
                      <div className="alert alert-danger" style={{ marginBottom: 0 }}>
                        ⚠️ {errorPagoExcedido}
                      </div>
                    </div>
                  ) : null}

                  <div className="row mt-4 mb-3">
                    <div className="col-xl-10 col-lg-12">
                      <FormSelectMaterial
                        placeholder="Método de pago"
                        label="Método de pago"
                        options={metodosPago}
                        id={'id_metodo_pago'}
                        error={errors.id_metodo_pago}
                        register={register}
                        onChange={handlerSelectMetodoPago}
                        value={idMetodoPago || ''}
                        disabled={metodosPago.length === 1}
                      />
                      {errors?.id_metodo_pago && <div className="invalid-feedback">{errors?.id_metodo_pago.message}</div>}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-6">
                      <button className="btn btn-sirio mt-3" type="submit" disabled={errorPagoExcedido || pagoTotal === 0}>
                        Continuar
                      </button>
                    </div>
                  </div>
                </form>
              </CardContainer>
            )}
            {showFirma && (
              <EntregasXProductorFirma
                data={dataForm}
                pagos={pagos}
                cuenta={cuenta}
                etiquetaAnticipos={etiquetaAnticipos}
                pendientePago={+pendientePago - +montoPagado - +recuperacionCredito}
                metodosPago={metodosPago}
              />
            )}
          </div>
          <div className="col-md-12 col-lg-5">
            <EntregasXProductorInfo uuid_cuenta={uuid_cuenta} id_cuenta={id_cuenta} id_acopio={id_acopio} entregas={entregas} />
          </div>
        </div>
      </CardContainer>
    </div>
  );
};

export default EntregasXProductorPagoPendiente;
